import { NgModule } from '@angular/core';
import { ReplacePipe } from './replace.pipe';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorIntlService } from './paginator-intl.service';
import { TranslateService } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ReplacePipe,
  ],
  exports: [
    ReplacePipe,
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useFactory: (translate) => {
        const service = new PaginatorIntlService();
        service.injectTranslateService(translate);
        return service;
      },
      deps: [TranslateService],
    },
  ],
})
export class TranslateHelperModule {
}
